<shortcut-menu [subscription]="subscription()">
  <tickets-item [messages]="activities()" />
  <grafana-item [subscription]="subscription()" />
</shortcut-menu>
